import React, { useState } from "react";
import "./Reviews.css";

const reviews = [
  {
    name: "Jeswin George",
    initial: "J",
    text: "Amazing Team, Amazing Work and Amazing Car after the clean. Their work was flawless. They took ample time to clean the car's interior. The time they took is testament to the fact that they are sincere and dedicated to their craft.",
  },
  {
    name: "Sarah Johnson",
    initial: "S",
    text: "Excellent service from start to finish. Professional, thorough, and my car has never looked better.",
  },
  {
    name: "Daniel Wright",
    initial: "D",
    text: "Very impressed with the attention to detail. Booking was easy and the result was outstanding.",
  },
];

function Reviews({ id }) {
  const [index, setIndex] = useState(0);

  const prev = () =>
    setIndex(index === 0 ? reviews.length - 1 : index - 1);
  const next = () =>
    setIndex(index === reviews.length - 1 ? 0 : index + 1);

  return (
    <section id={id} className="reviews-section">
      <div className="reviews-container">
        <h5 className="reviews-subtitle">CUSTOMER REVIEWS</h5>
        <h2 className="reviews-title">What Our Clients Say</h2>

        <div className="reviews-rating">
          ⭐⭐⭐⭐⭐ <span>5.0</span> from Google Reviews
        </div>

        <div className="review-wrapper">
          <button className="nav-btn left" onClick={prev}>‹</button>

          <div className="review-card">
            <div className="quote-icon">“</div>
            <div className="stars">⭐⭐⭐⭐⭐</div>

            <p className="review-text">“{reviews[index].text}”</p>

            <div className="review-user">
              <div className="avatar">{reviews[index].initial}</div>
              <span>{reviews[index].name}</span>
            </div>
          </div>

          <button className="nav-btn right" onClick={next}>›</button>
        </div>

        <div className="dots">
          {reviews.map((_, i) => (
            <span key={i} className={`dot ${i === index ? "active" : ""}`} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Reviews;
